(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-header.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-header.js');
"use strict";


const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const getAriaLabel = (eventItem, eventIndex, isMobile) => {
  const awayTeamShort = eventItem.awayTeamShort,
    awayTeamLong = eventItem.awayTeamLong,
    homeTeamShort = eventItem.homeTeamShort,
    homeTeamLong = eventItem.homeTeamLong;
  return "Match ".concat(eventIndex + 1, ", ").concat(isMobile ? "".concat(homeTeamShort, " mot ").concat(awayTeamShort) : "".concat(homeTeamLong, " mot ").concat(awayTeamLong), ".");
};
const EventRowHeader = _ref => {
  let eventIndex = _ref.eventIndex,
    eventItem = _ref.eventItem,
    branding = _ref.branding;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const captionShort = eventItem.captionShort,
    captionLong = eventItem.captionLong;
  return React.createElement("p", {
    "aria-label": getAriaLabel(eventItem, eventIndex, isMobile),
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center margin-bottom-0 coupon-score-event-header coupon-score-event-header-".concat(branding),
    "data-testid": "event-".concat(eventIndex, "-description")
  }, "".concat(isMobile ? captionShort : captionLong));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponScoreParts.EventRowHeader', EventRowHeader);

 })(window);